module.exports = __webpack_public_path__ + "images/FR-0f3948a095e749b9bbbc484664ab93ca.jpg";